<div
  *ngIf="hasCategory && !enableDesignSystemsUploader"
  class="file-upload-container"
  [formGroup]="formGroup"
  [class]="hideBorders ? 'no-borders' : ''"
>
  <div class="upload-row" *ngIf="!hideHeaderLabel">
    <span class="label">{{ label }}</span>
    <span
      class="chip"
      *ngIf="showUploadRemaining && uploadsRemaining"
      [innerHtml]="remainingUploadsIndicator(uploadsRemaining)"
    ></span>
  </div>
  <div
    class="upload-row"
    role="region"
    [attr.aria-label]="categoryLabel + ' ' + documentCategory?.value['displayValue']"
    *ngFor="let documentCategory of documentCategories | keyvalue: sort"
  >
    <div *ngIf="!enableDragDrop">
      <common-document-upload-worker
        [documentCategory]="documentCategory"
        [maxFileSize]="maxFileSize"
        [accept]="accept"
        [parentId]="parentId"
        [deleteMessage]="deleteMessage"
        [documentsUploaded]="getDocumentsBy(documentCategory.key)"
        [multipleDocument]="multipleDocument"
        [categoryLabel]="categoryLabel"
        [dataCy]="dataCy"
        [componentInitialized]="componentInitialized"
        [alwaysShowOptOut]="alwaysShowOptOut"
        (started)="onUploadStarted($event)"
        (uploadInProgress)="onUploadInProgress($event)"
        (fileUploaded)="onFileUploaded($event)"
        (optOutChanged)="onOptOutChanged($event)"
        (errorOccurred)="onErrorOccurred($event)"
        (completed)="onCompleted()"
      >
        <common-document-list
          [files]="getAllDocumentsBy(documentCategory.key)"
          [parentId]="parentId"
          [categoryDisplay]="documentCategory.value['displayValue']"
          (removeFile)="onRemoveFile($event)"
          [tooltipMessage]="tooltipMessage"
          [tooltipPosition]="tooltipPosition"
          [ariaLabelForPreviewIcon]="ariaLabelForPreviewIcon"
          [hideRemoveButton]="hideRemoveButton"
          [showDateUploaded]="showDateUploaded"
        >
        </common-document-list>
      </common-document-upload-worker>
    </div>

    <div *ngIf="enableDragDrop">
      <d3-drag-drop-worker
        [documentCategory]="documentCategory"
        [maxFileSize]="maxFileSize"
        [accept]="accept"
        [parentId]="parentId"
        [deleteMessage]="deleteMessage"
        [documentsUploaded]="getDocumentsBy(documentCategory.key)"
        [multipleDocument]="multipleDocument"
        [categoryLabel]="categoryLabel"
        [dataCy]="dataCy"
        [componentInitialized]="componentInitialized"
        [alwaysShowOptOut]="alwaysShowOptOut"
        [markAsTouched]="markAsTouched"
        [uploadedDocuments]="getAllDocumentsBy(documentCategory.key)"
        (started)="onUploadStarted($event)"
        (uploadInProgress)="onUploadInProgress($event)"
        (fileUploaded)="onFileUploaded($event)"
        (optOutChanged)="onOptOutChanged($event)"
        (errorOccurred)="onErrorOccurred($event)"
        (completed)="onCompleted()"
        [initialCanvasState]="getCanvasState(documentCategory.key)"
        (saveCanvasState)="saveCanvasState($event)"
        [skipUploadMore]="true"
        [allowEncryptedPDFs]="allowEncryptedPDFs"
        [allowFillablePdfs]="allowFillablePdfs"
        [uploaderAlwaysEnabled]="uploaderAlwaysEnabled"
      >
        <common-document-list
          [files]="getAllDocumentsBy(documentCategory.key)"
          [parentId]="parentId"
          [categoryDisplay]="documentCategory.value['displayValue']"
          (removeFile)="onRemoveFile($event)"
          [tooltipMessage]="tooltipMessage"
          [tooltipPosition]="tooltipPosition"
          [ariaLabelForPreviewIcon]="ariaLabelForPreviewIcon"
          [hideRemoveButton]="hideRemoveButton"
          [showDateUploaded]="showDateUploaded"
        >
        </common-document-list>
      </d3-drag-drop-worker>
    </div>
  </div>
</div>

<div
  *ngIf="hasCategory && enableDesignSystemsUploader"
  class="goab-file-upload-container"
  [formGroup]="formGroup"
  [class]="hideBorders ? 'no-borders' : ''"
>
  <div class="upload-row" *ngIf="!hideHeaderLabel">
    <span class="label">{{ label }}</span>
    <span
      class="chip"
      *ngIf="showUploadRemaining && uploadsRemaining"
      [innerHtml]="remainingUploadsIndicator(uploadsRemaining)"
    ></span>
  </div>
  <div
    class="upload-row"
    role="region"
    [attr.aria-label]="categoryLabel + ' ' + documentCategory?.value['displayValue']"
    *ngFor="let documentCategory of documentCategories | keyvalue: sort"
  >
    <goab-file-upload-worker
      [documentCategory]="documentCategory"
      [maxFileSize]="maxFileSize"
      [accept]="accept"
      [parentId]="parentId"
      [deleteMessage]="deleteMessage"
      [documentsUploaded]="getDocumentsBy(documentCategory.key)"
      [multipleDocument]="multipleDocument"
      [categoryLabel]="categoryLabel"
      [dataCy]="dataCy"
      [componentInitialized]="componentInitialized"
      [alwaysShowOptOut]="alwaysShowOptOut"
      [markAsTouched]="markAsTouched"
      [uploadedDocuments]="getAllDocumentsBy(documentCategory.key)"
      (started)="onUploadStarted($event)"
      (uploadInProgress)="onUploadInProgress($event)"
      (fileUploaded)="onFileUploaded($event)"
      (optOutChanged)="onOptOutChanged($event)"
      (errorOccurred)="onErrorOccurred($event)"
      (completed)="onCompleted()"
      [initialCanvasState]="getCanvasState(documentCategory.key)"
      (saveCanvasState)="saveCanvasState($event)"
      [skipUploadMore]="skipUploadMore"
      [allowEncryptedPDFs]="allowEncryptedPDFs"
      [allowFillablePdfs]="allowFillablePdfs"
      [hideDocumentCategoryLabel]="hideDocumentCategoryLabel"
      [hideUploaderLabel]="hideUploaderLabel"
      [hideUploadCanvas]="hideUploadCanvas"
      [imageSizeValidation]="imageSizeValidation"
      [validateDuplicate]="validateDuplicate"
    >
      <common-document-list
        [files]="getAllDocumentsBy(documentCategory.key)"
        [parentId]="parentId"
        [categoryDisplay]="documentCategory.value['displayValue']"
        (removeFile)="onRemoveFile($event)"
        [tooltipMessage]="tooltipMessage"
        [tooltipPosition]="tooltipPosition"
        [ariaLabelForPreviewIcon]="ariaLabelForPreviewIcon"
        [hideRemoveButton]="hideRemoveButton"
        [readOnlyList]="readOnlyList"
        [showDateUploaded]="showDateUploaded"
        [errorMessageTemplates]="resolvedErrorMessageTemplates"
        [validateDuplicate]="validateDuplicate"
      >
      </common-document-list>
    </goab-file-upload-worker>
  </div>
</div>

<ng-container *ngIf="errorMessageTemplates && ('protectedPdf' in errorMessageTemplates)">
  <ng-template #protectedPdf let-data>
    <!-- <goa-callout type="emergency">
      <style>
        ul {
          margin-top: 0;
        }
        li {
          line-height: 24px;
          margin-top: 6px;
        }
        li::marker {
          font-size: 0.6em;
        }
      </style>
      Bank statements downloaded from online banking are often password protected automatically.<br /><br />

      You can remove the password by following these steps:<br />
      <b>Option 1 - Re-save the PDF</b>
      <ul>
        <li>Open the PDF in your web browser or in a free Adobe Acrobat Reader</li>
        <li>Select "print" and "save as PDF"</li>
        <li>Save it under a new name and try to upload it again.</li>
      </ul>
      <b>Option 2 - Screenshot</b>
      <ul>
        <li>
          If Option 1 doesn't work, open the PDF and take clear screenshots of each page, then upload those images
          instead (JPG or PNG).
        </li>
      </ul>
    </goa-callout> -->
    <common-callout-content [calloutContent]="calloutErrorProtectedPdf"></common-callout-content>
  </ng-template>
</ng-container>
